module.exports = __webpack_public_path__ + "3579da040c9f3e55d897e768be7ce5f2.svg";